import React,{ useRef } from 'react';
import ZentorgaForm from '../components/ZentorgaForm';
import SoundVideo from '../components/SoundVideo';
import BenefitPeriod from '../../components/BenefitPeriod';
import { useFormSubmit } from '../hooks/useFormSubmit';
import { getImageArray } from '../utils/templateMapper';
import '../styles/zentorga.scss';
import '../styles/template11.scss';

/**
 * Template11 - 기본 단일 단계 폼
 * 구조: 이미지 → 혜택기간(선택) → 폼 → 버튼 → 서비스정보(선택) → 푸터
 */
const Template11 = ({
  landingData,
  urlCode,
  urlCodeSettingId
}) => {
  const { handleSubmit, isSubmitting } = useFormSubmit(
    urlCode,
    urlCodeSettingId,
    landingData.endpoint
  );

  const formRef = useRef(null);
  const images = getImageArray(landingData, 6);

  return (
    <section className="template11-layout zentorga-layout">
      {/* 이미지 섹션 */}
      {images.length > 0 && (
        <div className="template11-images zentorga-images">
          {images.map((img, idx) => {
            const fileExtension = img.url.split('.').pop().toLowerCase();
            const isVideo = ['mp4', 'webm', 'ogg', 'mov'].includes(fileExtension);

            return isVideo ? (
              <SoundVideo key={idx} src={img.url} loop={img.alt !== "false"} />
            ) : (
              <img key={idx} src={img.url} alt={img.alt} />
            );
          })}
        </div>
      )}

      {/* 이벤트 대상자 */}
      {landingData.eventTarget && (
        <div className="eventTarget">
          <p>이벤트 대상자 : <span className="event-target-text">{landingData.eventTarget}</span></p>
        </div>
      )}

      {/* 혜택 기간 */}
      {landingData.benefitDate && (
        <div className="benefitDate">
          <BenefitPeriod periodType={landingData.benefitDate} />
        </div>
      )}

      {/* 폼 섹션 */}
      <div className="formStyleClassName">
        <ZentorgaForm
          ref={formRef}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          formStyle={landingData.formStyleClassName || 'gray'}
          consentStyle={landingData.privacyPolicyClassName || 'dark'}
          privacyPolicyName={landingData.privacyPolicyName || '본원'}
          privacyPolicy={landingData.privacyPolicy}
          marketingPolicy={landingData.marketingPolicy}
          buttonComponent={
            <button
              type="button"
              className={`postBtn ${landingData.postBtnLocate === 'fixed' ? 'postBtn-fixed' : ''}`}
              id="postBtn"
              disabled={isSubmitting}
              onClick={() => {
                if (landingData.postBtnLocate === 'fixed') {
                  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                }
                formRef.current?.submitForm();
              }}
            >
              {landingData.postBtnUrl ? (
                <img src={landingData.postBtnUrl} alt="신청하기" />
              ) : (
                <span>{isSubmitting ? '신청 중...' : '신청하기'}</span>
              )}
            </button>
          }
        />
      </div>

      {/* 서비스 정보 */}
      {landingData.serviceInfoClassName && (
        <p
          className={`serviceInfoClassName ${landingData.serviceInfoClassName}`}
          id="serviceInfoClassName"
        >
          * 본 서비스는 전국 20여 개 이상의 제휴 병원에서 제공되며,<br />
          상담 신청 정보를 기반으로 전문 상담원이 적합한 제휴 병원을 안내해드립니다.
        </p>
      )}

      {/* 푸터 */}
      {landingData.footerClassName !== null && (landingData.footerClassName !== undefined || landingData.footerDetail) && (
        <footer className={`footerClassName ${landingData.footerClassName || ''}`}>
          {landingData.footerDetail && (
            <p className="footerDetail" style={{ whiteSpace: 'pre-line' }}>
              {landingData.footerDetail}
            </p>
          )}
        </footer>
      )}
    </section>
  );
};

export default Template11;
